import t from 'tcomb';
import getUUID from '../../getUUID';
import assign from 'lodash/object/assign';
import Field_Style from './style/Field_Style';
import Field_Target from './Field_Target';

const Field_Component = t.struct({
  style: t.maybe(Field_Style),
  targets: t.list(Field_Target),
  owner: t.Str
}, 'Field_Component');

Field_Component.prototype.to_form = function() {
  return assign({}, this, {
    id: getUUID(), // id temporaneo utile alla Form
    type: 'reducer/field'
  });
};

export default Field_Component;





/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Field_Component.js
 **/